<template>
  <transition name="slide">
    <div class="hs-container-child hs-container-child-page" v-if="show">
      <c-header class="c-header-new" :title="$t('ImportFromFrequentTraveler')" leftIcon1="icons_24pt_back.png" :leftFn1="close" />
      <hs-search-bar-new
          className="style2"
          v-model="KeyWord"
          :placeholder="$t('Search_1_x', 'function', [$t('Name')])"
          :hasClear="!!KeyWord"
          @clear="KeyWord = ''"
      />

      <hs-scroll
        class="table-view"
        ref="tableView"
        :style="tableViewStyle"
        :data="datalist"
        :options="tableViewOptions"
        @pulling-down="_getDatalist"
        @pulling-up="_getDatalistMore">
        <ul>
          <div style="width: 100%; height: 12px;"></div>
          <hs-null
              v-if="!datalist || datalist.length === 0"
              style="padding-top: calc(40dvh - 108px)"
              styleType="empty"
              :isGrayBg="true"
              :title="$t('NoDataContent')"
          />
          <div class="main-content">
            <passengers-item
                v-for="(item, index) in datalist"
                :key="index"
                :details="item"
                :Passengers="SelectedPassengers"
                @click.native="_select(item)"
            />
          </div>

          <div style="width: 100%; height: 50px;"></div>
        </ul>
      </hs-scroll>

      <footer v-if="SelectedPassengers.length > 0">
        <div class="btn-box">
          <hs-button class="btn" width="100%" height="46px" :fontSize="null" type="theme" @click="_confirm">
            {{ $t('ConfirmImportTraveler_x', 'function', [SelectedPassengers.length]) }}
          </hs-button>
        </div>
      </footer>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
import CHeader from 'components/c-header/c-header'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import HsNull from 'base/hs-null/hs-null'
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import HsTab from 'base/hs-tab/hs-tab'
import {kpiUserGetBookPersons, kpiFrequentTravelerImport} from 'api'
import mixinDes from 'common/mixin/passenger/mixin-des'
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import PassengersItem from "@/pages/personal/passengers/passengers-item.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
export default {
  data() {
    return {
      show: false,
      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      datalist: [],
      currentPageIndex: 1,
      currentPageSize: 20,
      KeyWord: '',
      SelectedPassengers: [],
    }
  },
  mixins: [mixinDes],
  watch: {
    show(val) {
      if (val) {
        this.SelectedPassengers = []
        this._getDatalist()
      }
    },
    KeyWord() {
      this.timer && clearTimeout(this.timer); // eslint-disable-line
      this.timer = setTimeout(() => {
        this._getDatalist()
      }, 500)
    },
  },
  computed: {
    tableViewStyle() {
      console.log(!this.datalist || this.datalist.length === 0)
      return {
        height: this.SelectedPassengers.length ? 'calc(100% - 48px - 56px - 62px)' : 'calc(100% - 48px - 56px)',
        backgroundColor: !this.datalist || this.datalist.length === 0 ? '#fff' : 'transparent'
      }
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    _getDatalist() {
      this.currentPageIndex = 1
      this.tableViewOptions.pullUpLoad = false
      let params = {
        KeyWord: this.KeyWord,
        PageIndex: this.currentPageIndex,
        PageSize: this.currentPageSize,
        TravelType: 0,
        ImportType: 1 // 常旅客
      }
      kpiUserGetBookPersons(params).then((res) => {
        console.log('常旅客列表： ', res)
        let list = res.ResultData
        list = this._handleList(list)
        list = list.filter(element => this.SelectedPassengers.map(v => v.ID).indexOf(element.ID) < 0)
        this.datalist = this.SelectedPassengers.concat(list)

        if (res.ResultData.length >= this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },
    _getDatalistMore() {
      let params = {
        KeyWord: this.KeyWord,
        PageIndex: this.currentPageIndex + 1,
        PageSize: this.currentPageSize,
        TravelType: 0,
        ImportType: 1 // 常旅客
      }
      kpiUserGetBookPersons(params).then((res) => {
        console.log('常旅客列表： ', res)
        this.currentPageIndex++
        let list = res.ResultData
        list = this._handleList(list)
        list = list.filter(element => this.SelectedPassengers.map(v => v.ID).indexOf(element.ID) < 0)
        this.datalist = this.datalist.concat(list)
        if (res.ResultData.length < this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = false
        } else {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    _handleList(list) {
      return (list || []).map(v => {
        return {
          ...v,
          FirstName: v.ENnameFirst,
          LastName: v.ENnameLast,
        }
      })
    },
    _select(item) {
      let index = this.SelectedPassengers.findIndex(v => v.ID === item.ID)
      if (index === -1) {
        this.SelectedPassengers.push(item)
      } else {
        this.SelectedPassengers.splice(index, 1)
      }
    },
    _confirm() {
      let params = {
        IDs: this.SelectedPassengers.map(v => v.ID),
        TravelType: 0
      }
      kpiFrequentTravelerImport(params).then((res) => {
        console.log('导入: ', res)
        if (res.ResultData) {
          this.$toast(this.$t('ImportSuccess'))
          this.close()
          // 成功回调 通知父级
          this.$emit('confirm')
        } else {
          this.$toast(this.$t('ImportFailed'))
        }
      })
    },
  },
  components: {
    HsButton,
    PassengersItem,
    HsSearchBarNew,
    CHeader,
    HsCell1,
    HsNull,
    HsScroll,
    HsSection,
    HsTab
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child
  @extend .flex-column
  @extend .flex-start
  position absolute
  width 100%
  height 100%
  left 0
  top 0
  bottom 0
  z-index 200
  &.hs-container-child-page{
    background-color $color_gray_background_0
  }
  .table-view
    width 100%
    height calc(100% - 45px - 53px)
    overflow hidden
    .main-content{
      background $color_black_0
      border-radius 12px
      width calc(100% - 24px)
      margin-left 12px
      overflow hidden
    }
  > footer {
    width: 100%;
    background: $color_black_0;
    border-radius: 12px 12px 0 0;

    > .btn-box {
      padding: 8px 12px;
    }
  }
</style>
